import React, {useRef, useState} from 'react'
import './Join.css'
import emailjs from '@emailjs/browser'

const Join = () => {
    const form =useRef();
    const [emailError, setEmailError] = useState('');

    

    const sendEmail = (e) => {
        e.preventDefault();
        const userEmail = form.current.user_email.value;

        if (!userEmail) {
            setEmailError('Email is required');
            return;
        }
    
        emailjs
          .sendForm('service_5w8krhp', 'template_bvhfban', form.current, {
            publicKey: 'G2CruiECGl8d5lr7N',
          })
          .then(
            () => {
              console.log('SUCCESS!');
            },
            (error) => {
              console.log('FAILED...', error.text);
            },
          );
      };
  return (
    <div className='Join'>
        <div className='left-j'>
            <hr />
            <div>
                <span className='stroke-text'>READY TO</span>{" "}
                <span>LEVEL UP</span>
            </div>
            <div>
                <span >YOUR BODY</span>{" "}
                <span className='stroke-text'>WITH US?</span>
            </div>
            
        </div>
        <div className='right-j'>
                <form ref={form} action='' className='email-container' onSubmit={sendEmail}>
                    <input type="email" name="user_email" placeholder='Enter Your Email'
                    onChange={() => setEmailError('')}/>
                    <button className='joinbtn'>Join Now</button>

                </form>
                {emailError && <div className="email-error">{emailError}</div>}
        </div>
    </div>
  )
}

export default Join